"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedInsuredsAutoComplete = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var next_newfront_api_1 = require("@newfront-insurance/next-newfront-api");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var auto_complete_search_results_1 = __importDefault(require("./components/auto-complete-search-results"));
var types_1 = require("./types");
function formatter(namedInsured) {
    var _a;
    var id = namedInsured.id, name = namedInsured.name, dba = namedInsured.dba, address = namedInsured.address;
    var cityStateZip = (address === null || address === void 0 ? void 0 : address.city) + ", " + types_1.stateCodeToName.get(address === null || address === void 0 ? void 0 : address.state) + " " + (address === null || address === void 0 ? void 0 : address.zip);
    return {
        title: [name, dba || ''],
        subtitle: [(_a = address === null || address === void 0 ? void 0 : address.street) !== null && _a !== void 0 ? _a : '', cityStateZip],
        key: id,
        testId: id,
        isDefault: id === 'default',
    };
}
var LoadingField = function () { return (react_1.default.createElement(core_ui_1.Field, { fieldId: "namedInsured", label: "Select a named insured*" },
    react_1.default.createElement(core_ui_1.LoadingTextInput, null))); };
function NamedInsuredsAutoComplete(_a) {
    var clientUuid = _a.clientUuid, placeholder = _a.placeholder, initialQuery = _a.initialQuery, onSelectValue = _a.onSelectValue, error = _a.error, maxHeight = _a.maxHeight;
    var data = next_newfront_api_1.useGetNamedInsuredsByClientUuid(clientUuid).data;
    var _b = react_1.useState(initialQuery || null), selectedSearchQuery = _b[0], setSelectedSearchQuery = _b[1];
    var _c = react_1.useState(initialQuery || null), search = _c[0], setSearch = _c[1];
    var _d = react_1.useState(false), searchFocused = _d[0], setSearchFocused = _d[1];
    var _e = react_1.useState(null), namedInsured = _e[0], setNamedInsured = _e[1];
    var _f = react_1.useState(null), filteredNamedInsured = _f[0], setFilteredNamedInsured = _f[1];
    react_1.useEffect(function () {
        setNamedInsured(data || null);
    }, [data]);
    if (!namedInsured)
        return react_1.default.createElement(LoadingField, null);
    /**
     * filter
     * @param value
     * filter existing named insured
     */
    function filter(value) {
        var val = value.toLowerCase();
        if (!namedInsured)
            return;
        var filteredResults = namedInsured.filter(function (_a) {
            var name = _a.name, dba = _a.dba;
            return name.toLowerCase().includes(val) || (dba && dba.toLowerCase().includes(val));
        });
        setFilteredNamedInsured(filteredResults);
    }
    function handleSelect(value) {
        setSearchFocused(false);
        setSearch(null);
        setSelectedSearchQuery(null);
        onSelectValue(value);
    }
    function reset() {
        setSearchFocused(false);
        setSearch(null);
        setSelectedSearchQuery(null);
    }
    return (react_1.default.createElement(StyledAutoCompleteSearch, { onBlur: reset },
        react_1.default.createElement(core_ui_1.Field, { fieldId: "namedInsured", label: "Named insured*", error: error },
            react_1.default.createElement(core_ui_1.Input, { type: "search", placeholder: placeholder || 'Search or create new...', onChange: function (value) {
                    setSearchFocused(true);
                    setSelectedSearchQuery(null);
                    setSearch(value);
                    if (value) {
                        filter(value);
                    }
                    else {
                        setFilteredNamedInsured(null);
                    }
                }, onFocus: function () { return setSearchFocused(true); }, value: selectedSearchQuery || search || '', testId: "search-input" })),
        searchFocused && data && (react_1.default.createElement(auto_complete_search_results_1.default, { maxHeight: maxHeight, formatter: formatter, results: filteredNamedInsured || namedInsured, onSelect: handleSelect, defaultItemLabel: "Primary named insured" }))));
}
exports.NamedInsuredsAutoComplete = NamedInsuredsAutoComplete;
var StyledAutoCompleteSearch = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 3;\n"], ["\n  position: relative;\n  z-index: 3;\n"])));
var templateObject_1;
